import axiosInstance from "../config/axiosInstance";
import API from "../config/config";
import { toast } from "react-toastify";

class CommissionService {
  // Get dashboard revenue metrics
  static async getRevenueMetrics(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `${API.ADMIN.COMMISSION_REVENUE_METRICS}?${queryString}`
        : API.ADMIN.COMMISSION_REVENUE_METRICS;

      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching revenue metrics:", error);
      toast.error("Failed to fetch revenue metrics");
      throw error;
    }
  }

  // Get commission report
  static async getCommissionReport(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(
        `${API.ADMIN.COMMISSION_REPORT}?${queryString}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching commission report:", error);
      toast.error("Failed to fetch commission report");
      throw error;
    }
  }

  // Get detailed commission report
  static async getDetailedCommissionReport(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(
        `${API.ADMIN.COMMISSION_REPORT_DETAILED}?${queryString}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching detailed commission report:", error);
      toast.error("Failed to fetch detailed commission report");
      throw error;
    }
  }

  // Update commission payment status
  static async updateCommissionPaymentStatus(driverPhone, commissionAmount) {
    try {
      const response = await axiosInstance.post(
        API.ADMIN.DRIVER_UPDATE_COMMISSION,
        { driverPhone, commissionAmount }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating commission payment status:", error);
      toast.error("Failed to update payment status");
      throw error;
    }
  }

  static async uploadPhonePeSettlementReport(file) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axiosInstance.post(
        API.ADMIN.COMMISSION_PHONEPE_SETTLEMENT_UPLOAD,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error uploading PhonePe settlement report:", error);
      toast.error("Failed to upload settlement report");
      throw error;
    }
  }

  static async getPhonePeSettlementReport(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `${API.ADMIN.COMMISSION_PHONEPE_SETTLEMENT_LIST}?${queryString}`
        : API.ADMIN.COMMISSION_PHONEPE_SETTLEMENT_LIST;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching PhonePe settlement report:", error);
      toast.error("Failed to fetch settlement report");
      throw error;
    }
  }

  static async getTaxInvoiceSummary(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(
        `${API.ADMIN.COMMISSION_TAX_INVOICE_SUMMARY}?${queryString}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tax invoice summary:", error);
      toast.error("Failed to fetch tax invoice data");
      throw error;
    }
  }

  static async getTaxInvoiceStatewise(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axiosInstance.get(
        `${API.ADMIN.COMMISSION_TAX_INVOICE_STATEWISE}?${queryString}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching statewise tax invoice:", error);
      toast.error("Failed to fetch statewise tax data");
      throw error;
    }
  }
}

export default CommissionService;
